// 所有表格行相同的配置
const columnPublicConfig = {
    align: 'center'
}

// 筛选器配置
const filterItemsConfig = {
    scopedSlots: {
        filterDropdown: 'filterDropdown',
        filterIcon: 'filterIcon'
    }
}

// 编辑内容配置
export const formModel = {
    admin_id: {
        title: '经销商名称',
        type: 'select',
        value: '',
        items: [],
        rules: [{
            required: true,
            message: '请选择经销商名称'
        }]
    },
    title: {
        title: '卡号前缀',
        type: 'select',
        value: '',
        items: [],
        rules: [{
            required: true,
            message: '请选择卡号前缀'
        }]
    },
    min: {
        title: '最小值',
        type: 'inputNumber',
        min: 0,
        value: '',
        rules: [{
            required: true,
            message: '请输入最小值'
        }]
    },
    max: {
        title: '最大值',
        type: 'inputNumber',
        min: 0,
        value: '',
        rules: [{
            required: true,
            message: '请输入最大值'
        }]
    },
    js_time: {
        title: '过期时间',
        type: 'date',
        value: '',
        rules: [{
            required: true,
            message: '请选择过期时间'
        }]
    }
}

// 表格配置
/**
 * title: 表格标题
 * dataIndex: 后端返回的这个标题的名字
 * filterIndex: 筛选器字段，一般和dataIndex一样，如果是选择型的筛选器，这里填写id字段
 * key: 随便选择dataIndex或filterIndex中的一个
 * type: 筛选器类型，input = 输入框，select = 选择框
 * multi: 如果选择型筛选器需要多选，就写上值为true
 * items: 选择型筛选器必须带上这个，默认为空数组
 */
export const columns = [
    {
        title: '卡号',
        dataIndex: 'card',
        filterIndex: 'card',
        key: 'card',
        type: 'input',
        ...columnPublicConfig,
        ...filterItemsConfig
    },
    {
        title: '用户名',
        dataIndex: 'usrt_id',
        filterIndex: 'usrt_id',
        key: 'usrt_id',
        type: 'input',
        ...columnPublicConfig,
        ...filterItemsConfig
    },
    {
        title: '经销商名称',
        dataIndex: 'admin_name',
        key: 'admin_name',
        ...columnPublicConfig
    },
    {
        title: '使用状态',
        dataIndex: 'admin_type',
        key: 'admin_type',
        width: 240,
        scopedSlots: {
            customRender: 'c-type'
        },
        ...columnPublicConfig
    },
    {
        title: '余额',
        dataIndex: 'clip_money',
        key: 'clip_money',
        scopedSlots: {
            customRender: 'c-money'
        },
        ...columnPublicConfig
    },
    {
        title: '月扣款金额',
        dataIndex: 'debit',
        key: 'debit',
        ...columnPublicConfig
    },
    {
        title: '下次扣款时间',
        dataIndex: 'kf_time',
        key: 'kf_time',
        ...columnPublicConfig
    },
    // {
    //     title: '操作',
    //     dataIndex: 'action',
    //     key: 'action',
    //     width: 160,
    //     scopedSlots: {
    //         customRender: 'c-action'
    //     }
    // }
]
